import { TradingEffects } from './effects/trading.effects';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TradingReducer } from './reducers/trading.reducers';
import { TradingFacades } from './facades/trading.facades';


@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('trading', TradingReducer),
        EffectsModule.forFeature([TradingEffects])
    ],
    providers: [TradingFacades]
})
export class TradingStoreModule { }
